export default "__VITE_ASSET__SpRucz3f__"